import { formatMessage } from './chat.transform';
import { mutations } from './chat.d';

export default {
  /**
   * Used to replace the whole messages array
   */
  [mutations.setMessages](state, newMessages) {
    const formatter = formatMessage();
    const formattedMessages = newMessages.map(formatter);
    state.messages = formattedMessages;
  },

  /**
   * Prepend the older messages at the beginning of messages
   */
  [mutations.insertOlderMessages](state, olderMessages) {
    const { messages } = state;
    const prevSenderId = messages.length > 0 ? messages[0].sender.userId : '';
    const formatter = formatMessage(prevSenderId);
    const formattedMessages = olderMessages.map(formatter);

    state.messages.unshift(...formattedMessages);
  },

  /**
   * Used to insert new message temporarily
   * before the real message is successfully sent
   */
  [mutations.insertNewMessage](state, message) {
    const { messages } = state;
    const prevSenderId = messages.length > 0 ? messages[0].sender.userId : '';
    const formatter = formatMessage(prevSenderId);
    const formattedMessage = formatter(message);

    state.messages.push(formattedMessage);
  },

  /**
   * Used to replace former temporary message
   * with correct information from chat service
   */
  [mutations.resolveNewMessage](state, newMessage) {
    const formatter = formatMessage();
    const incomingMessage = formatter(newMessage);
    const selectedMessage = state.messages.find(
      message => message.reqId && message.reqId === incomingMessage.reqId
    );
    Object.assign(selectedMessage, incomingMessage);
  },

  [mutations.setChannel](state, channel) {
    state.currentChannel = channel;
  },

  [mutations.clearChannel](state) {
    state.currentChannel = {};
  }
};
